/**
 * @description
 * This handle the 3 states of the loan application:
 * + the first form
 * + the come back
 * + the results retrieval
 *
 * @param {string} locale
 * @param {string} version
 */
function Questionnaire(locale, version) {
  this.domain = location.origin;
  this.locale = parseLocale(locale);
  this.acceptLanguageHeader = parseLocale(locale).toLowerCase();

  this.partnersLocale = getParameterByName("partnersLocale");
  if (this.partnersLocale && this.partnersLocale.length !== 0 && this.partnersLocale !== 'default' && isValidLocale(this.partnersLocale)) {
    this.locale = this.partnersLocale;
  }else{
    this.partnersLocale = 'default';
  }

  this.isLocalEnv = this.domain.indexOf('local') !== -1;

  this.endpoint = (this.domain.indexOf('october.eu') === -1) || (this.domain.indexOf('next') !== -1)
  ? this.isLocalEnv
    ? '//api.october.local:8081/'
    : '//staging-api.october.eu/'
  : '//api.october.eu/';

  this.o5rVersion = version;

  this.referrer = getParameterByName("referrer");

  this.answers = {};
  const answers = window.localStorage.getItem('answers');
  if (answers) {
    this.answers = JSON.parse(answers);
  }

  // We only initialize inputs and components if they are present in the DOM
  if ($('input[name="first-name"]').length !== 0) {
    this.$firstname = $('input[name="first-name"]');
    this.setObservers(this.$firstname);
  }

  if ($('input[name="last-name"]').length !== 0) {
    this.$lastname = $('input[name="last-name"]');
    this.setObservers(this.$lastname);
  }

  if ($('input[name="email"]').length !== 0) {
    this.$email = $('input[name="email"]');
    this.setObservers(this.$email);
  }

  if ($('#business-input').length !== 0) {
    let question = getParameterByName('question');
    let company = undefined;

    if(question === 'company' && this.answers.company){
      company = {};
      company.code = {
        'id': this.answers.company.id,
        'type': this.answers.company.type
      }
      company.name = this.answers.company.name;
    }

    if(question === 'acquired-company'){
      // on this screen we don't want to send "company = uundefined" to the business-input instance
      // cause if we do that it will try to fetch the company id from the query params and get the id of the acquiring company, not the acquired one
      company = {
        'code': {
          'id': '',
          'type': ''
        }
      };
      if(this.answers['loan-type'].code){
        company.code = this.answers['loan-type'].code;
        company.name = this.answers['loan-type'].name;
      }
    }

    this.$businessInput = new BusinessInput($('#business-input'), company, this.locale, undefined);
    this.$businessId = $('#business-id');
    this.setObservers(this.$businessId);
  }

  // Initializing money-input
  if ($("input[name='amount']").length !== 0) {
    this.$amount = $("input[name='amount']");
    this.$minAmount = parseInt(this.$amount.attr('min'));
    this.$maxAmount = parseInt(this.$amount.attr('max'));
    this.initMoneyInput();
    this.setObservers(this.$amount);
  }
  // Initializing ESG
  if ($("input[name='esg']").length !== 0) {
    this.$esgPurpose = $('input[name="esg"]');
    this.$buttons = $('button#no');
    this.setObservers(this.$buttons);
  }

  // Initializing phone-input
  if ($('#phone-input').length !== 0)  {
    this.$phoneNumber = $('input[name="phone-number"]');
    this.$areaCode = $('#area-code');
    this.$countryCode = $('input[name="country-code"]');

    this.populateCountryCodes();

    this.phoneMask = {
      'max': 10,
      'min': 9,
      'areaCode': null,
      'pattern': '[0-9]*'
    };

    this.setPhoneInputs();
    this.setObservers(this.$phoneNumber);
  }

  // sidebar without leasing
  if(!this.isLeaseAvailable()){
    $('aside .section.loan-type').addClass('d-none');
  }
}

Questionnaire.prototype.debounce = (func, timeout = 300) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args) }, timeout);
  }
}

/**
 * check validity of inputs while typing corrections
 * @param {*} observer
 */
Questionnaire.prototype.setObservers = function(observer) {
  const _this = this;
  observer.on('change input click',
    _this.debounce(() => {
      if(observer.hasClass('error')){_this.validate();}
      if(getParameterByName('question') === 'esg-purpose'){_this.validate();}
    })
  );
}

Questionnaire.prototype.questions = ['company', 'amount', 'loan-type', 'esg-purpose', 'personal-info', 'finalize-application'];

// Money-input related functions
Questionnaire.prototype.initMoneyInput = function() {
  // money inputs
  let prefix = "";
  let suffix = " €";
  let thousands = " ";

  if (this.locale === "EN") {
    prefix = "€";
    suffix = "";
    thousands = ",";
  }

  this.$amount.maskMoney({
    prefix: prefix,
    suffix: suffix,
    thousands: thousands,
    precision: 0,
    allowNegative: false
  });
}

// Phone-input related functions
Questionnaire.prototype.countryCodes = [
  {"country":"AE","code":"971"},
  {"country":"AT","code":"43"},
  {"country":"BE","code":"32"},
  {"country":"CA","code":"1"},
  {"country":"CH","code":"41"},
  {"country":"DE","code":"49"},
  {"country":"EE","code":"372"},
  {"country":"ES","code":"34"},
  {"country":"FR","code":"33"},
  {"country":"GB","code":"44"},
  {"country":"GF","code":"594"},
  {"country":"GP","code":"590"},
  {"country":"IE","code":"353"},
  {"country":"IT","code":"39"},
  {"country":"LU","code":"352"},
  {"country":"MQ","code":"596"},
  {"country":"MX","code":"52"},
  {"country":"NC","code":"687"},
  {"country":"NL","code":"31"},
  {"country":"PF","code":"689"},
  {"country":"PT","code":"351"},
  {"country":"RE","code":"262"},
  {"country":"SE","code":"46"},
  {"country":"SG","code":"65"},
  {"country":"YT","code":"262"}
];

Questionnaire.prototype.populateCountryCodes = function(selectedCountry = undefined) {
  const countryCodes = this.countryCodes;
  const locale = selectedCountry || this.locale === "EN" ? "GB" : this.locale;

  countryCodes.forEach((value) => {
    const option = $("<li />")
      .val(value.code)
      .html(`<div class='name'>${value.country} (+${value.code})</div>`);

    if (value.country === locale) {
      this.$countryCode.val(`${value.country} (+${value.code})`);
      option.toggleClass('selected');
    }

    option.click(() => {
      $('#country-list li').removeClass('selected');
      option.addClass('selected');
      this.$countryCode.val(`${value.country} (+${value.code})`);
      this.setPhoneInputs();
    });

    $("#country-list").append(option);
  });

  $(".select-input#country-code").click(() => {
    $('#country-list').toggle();

    if ($('#country-list').css('display') !== 'none') {
      $('form').css('z-index', 1);
      $('.actions').css('z-index', -1);
    }
  });

  $(document).click((e) => {
    if (!$(".select-input#country-code").is(e.target) && $(".select-input#country-code").has(e.target).length === 0) {
      $('#country-list').hide();
      $('form').css('z-index', 0);
      $('.actions').css('z-index', 0);
    }
  });
}

Questionnaire.prototype.setPhoneMask = function() {
  const code = $('#country-list li.selected').val();

  //- NL
  if (code === 31) {
    this.phoneMask.max = 8;
    this.phoneMask.min = 8;
    this.phoneMask.areaCode = 6;
  //- DE
  } else if (code === 49) {
    this.phoneMask.max = 16;
    this.phoneMask.min = 7;
    this.phoneMask.areaCode = null;
  //- IT
  } else if (code === 39) {
    this.phoneMask.max = 11;
    this.phoneMask.min = 6;
    this.phoneMask.areaCode = null;
  //- default FR, ES
  } else {
    this.phoneMask.max = 10;
    this.phoneMask.min = 9;
    this.phoneMask.areaCode = null;
  }
}

Questionnaire.prototype.setPhoneInputs = function() {
  this.setPhoneMask();

  this.$phoneNumber.attr('maxlength', this.phoneMask.max);
  this.$phoneNumber.attr('minlength', this.phoneMask.min);

  if(this.phoneMask.areaCode){
    this.$areaCode.html(this.phoneMask.areaCode);
    this.$phoneNumber.css('padding-left', this.$areaCode.css('width'));
  } else{
    this.$areaCode.html('');
    this.$phoneNumber.css('padding-left', 13);
  }
}

/**
 * Function called when the user clicks on Continue
 * Parses the inputs and set the localStorage with the question query param
 *
 * @param {*} event
 */
Questionnaire.prototype.submit = function(event) {
  let question = getParameterByName('question');
  let step = getParameterByName('step');
  let value = undefined;

  if (!this.validate()) {
    event.preventDefault();
    return;
  }
  // start screen
  if(!question && !step) question = 'hardcuts';

  switch(question) {
    case 'hardcuts':
      if (getParameterByName('type')){
        value = {
          'type': getParameterByName('type'),
          'id' : getParameterByName('id'),
        }
        if (getParameterByName('company')) value.name = getParameterByName('company');
        value.label = `${value.type.toUpperCase()} ${value.id}`;
        question = 'company';
      }else{
        value = undefined;
      }
      break;

    case 'acquired-company':
      value = this.answers['loan-type'];
      if (value.code) {
        value.label = value.label.split('<br>')[0];
      }
      value.code = this.$businessInput.company.code;
      value.name = this.$businessInput.company.name;
      value.label += `<br>${value.code.type.toUpperCase()} ${value.code.id}`;
      question = 'loan-type';
      break;

    case 'company':
      value = this.$businessInput.company.code;
      value.name = this.$businessInput.company.name;
      value.label = `${value.type.toUpperCase()} ${value.id}`;
      break;

    case 'amount':
      value = {
        label: this.$amount.val(),
        value: parseInt(this.$amount.maskMoney("unmasked")[0]) * 100
      };
      break;

    case 'loan-type':
      value = this[question];
      break;

    case 'esg-purpose':
      value = this[question];
      break;

    case 'personal-info':
      const lname = this.$lastname.val();
      const fname = this.$firstname.val();
      value = {
        firstname: fname.replace(/^\w/, function (chr) {
          return chr.toUpperCase();
          }),
        lastname: lname.replace(/^\w/, function (chr) {
          return chr.toUpperCase();
          }),
        phone: {
          countryCode: $('#country-list li.selected').val(),
          number: `${this.$areaCode.html()}${this.$phoneNumber.val()}`,
        }
      };
      break;

    case 'finalize-application':
      value = { email: this.$email.val() };
      break;

    default:
      break;
  }

  if (value) {
    this.answers[question] = value;

    window.localStorage.setItem('answers', JSON.stringify(this.answers));
  }

  this.debounce(this.next(event), 500);

}

/**
 * Restore the values
 * Retrieve the answers in the localStorage with the question key and reapply them to the proper inputs
 */
Questionnaire.prototype.restore = function() {
  const question = getParameterByName('question');
  const step = getParameterByName('step');

  if (this.answers[question] || (question === 'acquired-company' && this.answers['loan-type'])) {
    let answer = this.answers[question];

    this.enable();
    switch(question) {
      case 'acquired-company':
        answer = this.answers['loan-type'] || {};
        break;

      case 'company':
        this.$businessId.focus();
        break;

      case 'amount':
        this.$amount.val( answer.value/100 ).focus();
        break;

      case 'loan-type':
      case 'esg-purpose':
        if(answer.value === 'none'){
          $('#no').addClass('selected');
        } else{
          $(`.select-element.${answer.value}`).addClass('selected');
          $(`.select-element.${answer.value} input[type=radio]`).prop('checked', true);
          $('#yes').addClass('selected');
          $('.radio-list').removeClass('d-none');
        }
        this[question] = answer;
        break;

      case 'personal-info':
        this.$firstname.val(answer.firstname);
        this.$lastname.val(answer.lastname);

        const codes = Object.values(this.countryCodes);
        const countryCode = codes.filter((value) => value.code == answer.phone.countryCode)[0];

        $("#country-list li").removeClass('selected');
        $(`#country-list li[value=${countryCode.code}]`).addClass('selected');
        this.$countryCode.val(`${countryCode.country} (+${countryCode.code})`);

        this.setPhoneInputs();
        this.$phoneNumber.val(answer.phone.number.substring(this.$areaCode.html().length));
        break;

      case 'finalize-application':
        this.$email.val(answer.email);
        this.disable();
        break;

      default:
        break;
    }

  } else if (question) {
    switch(question) {
      case 'amount':
      case 'personal-info':
      case 'company':
      case 'acquired-company':
      case 'esg-purpose':
        this.enable();
        break;

      default:
        this.disable();
    }

  } else if (step === 'error') {
    this.throwError();

  } else {
    this.enable();
  }
}

Questionnaire.prototype.isValidName = function()  {
  const str = this.$firstname.val() + " " + this.$lastname.val();
  const allowedChars = /^[-,'.a-z\d€\u00c0-\u024f\u1e00-\u1eff ]+$/i;
  return str.length >= 5
    && str.length <= 100
    && str.includes(' ')
    && allowedChars.test(str);
}

Questionnaire.prototype.validate = function() {
  const question = getParameterByName('question');
  let isValid;

  switch(question) {
    case 'amount':
      const amount = this.$amount.maskMoney("unmasked")[0];
      isValid = amount >= this.$minAmount && this.$maxAmount >= amount;

      if (isValid) {
        this.$amount.removeClass('error');
      } else {
        this.$amount.addClass('error');
        $('b#min').html(currencyFormatI18n(this.$minAmount, 0, this.locale));
        $('b#max').html(currencyFormatI18n(this.$maxAmount, 0, this.locale));
      }
      break;

    case 'personal-info':
      const isValidName = this.$firstname.val() !== '' && this.$lastname.val() !== '' && this.isValidName();
      const isValidPhone = this.$phoneNumber[0].checkValidity();
      isValid = isValidName && isValidPhone;

      if (isValidName) {
        this.$firstname.removeClass('error');
        this.$lastname.removeClass('error')
      } else {
        this.$firstname.addClass('error');
        this.$lastname.addClass('error')
      }
      if (isValidPhone) {
        this.$phoneNumber.removeClass('error');
      } else {
        this.$phoneNumber.addClass('error');
      }
      break;

    case 'company':
    case 'acquired-company':
      this.$businessId.focus();
      this.$businessInput.onBlur();

      isValid = this.$businessId.val() !== '';

      if(isValid) {
        this.$businessId.removeClass('error');
      } else {
        this.$businessId.addClass('error');
      }
      break;

    case 'esg-purpose':
      isValid = $('#no').hasClass('selected') ||
                ( $('#yes').hasClass('selected') && this.$esgPurpose.is(':checked') );

      if(isValid) {
        $('p.error').addClass('d-none');
      } else {
        if( $('.esg-question button').hasClass('selected') ){
          $('.radio-list p.error').removeClass('d-none').smoothScrollTop();
          $('.esg-question p.error').addClass('d-none');
        } else {
          $('.esg-question p.error').removeClass('d-none').smoothScrollTop();
        }
      }
      break;

    case 'finalize-application':
      const regex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;

      isValid = regex.test(this.$email.val());

      if(isValid) {
        this.$email.removeClass('error');
      } else {
        this.$email.addClass('error');
      }
      break;

    default:
      isValid = true;
      break;
  }
  return isValid;
}

/**
 * Disable or enable submit button
 */
Questionnaire.prototype.enable = function() {
  $('.actions button').prop('disabled', false);
}

Questionnaire.prototype.disable = function() {
  $('.actions button').prop('disabled', true);
}

Questionnaire.prototype.addBuyoutQuestion = function() {
  if (this.questions.indexOf('acquired-company') === -1) {
    const i = this.questions.indexOf('loan-type');
    this.questions.splice(i + 1, 0, 'acquired-company');
  }
}

Questionnaire.prototype.deleteBuyoutQuestion = function() {
  const i = this.questions.indexOf('acquired-company');
  if(i !== -1) {this.questions.splice(i, 1);}
  window.localStorage.removeItem('acquired-company');
}

/**
 * Sets the next question/step
 * @param {*} event
 */
Questionnaire.prototype.next = function(event) {
  const company = this.answers['company'];
  const loanType = this.answers['loan-type'];
   // Add question about company acquisition if buyout is selected
   if (loanType && loanType.value === 'acquisition') {
    this.addBuyoutQuestion();
  } else {
    this.deleteBuyoutQuestion();
  }

  const question = getParameterByName('question');
  let index = this.questions.indexOf(question) + 1;


// skipping 'company' question because user already filled the business-input on the homepage
  if (!getParameterByName('step') && !getParameterByName('question')) {
    if(company && company.id) index++;
  }

  // Skipping loan type question if company is neither FR or ES
  if (this.questions[index] === 'loan-type' && !this.isLeaseAvailable()) {
    index++;
  }

  if (index === this.questions.length) {
    this.send();
  } else {
    replaceParamByName({
      question: this.questions[index],
      step: undefined,
      flush: undefined
    });
  }

  event.preventDefault();
}

/**
 * Sets the previous question/step
 * @param {*} event
 */
Questionnaire.prototype.previous = function(event) {
  const question = getParameterByName('question');
  const index = this.questions.indexOf(question) - 1;

  if (!this.questions[index]) {
    replaceParamByName({question: undefined});
  }

  else {
    replaceParamByName({question: this.questions[index]});
  }

  event.preventDefault();
}

/**
 * Custom select function for the .select-list component
 *
 * @param {*} event
 * @param {*} key
 * @param {*} field
 */
Questionnaire.prototype.selectValue = function(event, key, field) {
  if($(`.select-element.${field.value} input[type=radio]`).length == 0){
    event.preventDefault();
  }
  $('.select-element').removeClass('selected');
  $(`.select-element.${field.value}`).addClass('selected');
  $(`.select-element.${field.value} input[type=radio]`).prop('checked', true).change();

  this[key] = field;
  this.enable();
}
Questionnaire.prototype.esgQuestion = function(event) {
    event.preventDefault();
    $('.esg-question button').removeClass('selected');
    $('#' + event.target.id).addClass('selected');

    if( event.target.id == 'yes') {
      $('.radio-list').removeClass('d-none');
      $('.esg-question p.error').addClass('d-none');
    }
    if( event.target.id == 'no') {$('.radio-list').addClass('d-none')}

}

/**
 * Custom function for the .check-box component
 *
 * @param {*} event
 * @param {*} key
 * @param {*} field
 */
Questionnaire.prototype.checkValue = function(event, key) {
  $(`.check-box#${key}`).toggleClass('checked');

  const totalCheckBoxes = $('.check-box').length;
  let areAllChecked = true;

  for(let i=0; i<totalCheckBoxes; i++) {
    areAllChecked &= $('.check-box')[i].className.includes('checked');
  }

  if (areAllChecked) {
    this.enable();
  } else {
    this.disable();
  }

  event.preventDefault();
}

Questionnaire.prototype.backAction = function(event) {
  event.preventDefault();

  window.location = "/";
}

/**
 * Format localStorage object to send to the API
 */
Questionnaire.prototype.getParameters = function() {
  const questions = this.questions;
  const answers = this.answers;
  const params = {};

  const source = Cookies.get("source");
  if(source){ params.source = source; }

  if(this.referrer){ params.referredBy = this.referrer; }

  questions.forEach((question) => {
    const answer = answers[question];

    switch(question) {
      case 'company':
        delete answer.name;
        delete answer.label;
        params.code = answer;
        break;
      case 'amount':
        params.amount = answer.value;
        break;
      case 'loan-type':
        params['type'] = 'loan';
        params.reasons = [answer.value];
        params.duration = answer.duration;
        break;
      case 'esg-purpose':
        params.esgPurposes = [answer.value];
        break;
      case 'personal-info':
        params.name = answer.firstname + " " + answer.lastname;
        params.phone = answer.phone;
        break;
      case 'finalize-application':
        params.email = answer.email;
        break;
      default:
        break;
    }
  });

  return params;
}

/**
 * Sending data to the API
 */
Questionnaire.prototype.send = function() {
  const _this = this;
  const params = _this.getParameters();
  const headers = { "Accept-Language": _this.acceptLanguageHeader };
  if(this.o5rVersion !== null) headers['October-Version'] = this.o5rVersion;

  $('section#questionnaire').hide();
  $('section#loading').show();

  $.ajax({
    url: _this.endpoint + "requests",
    type: "post",
    headers: headers,
    dataType: "json",
    data: params,
    success: function(response) {
      _this.track("eligibility-sent", params);
      Cookies.remove('referrer');
      window.localStorage.removeItem('answers');
      window.localStorage.removeItem('response');
      replaceParamByName({
        question: undefined,
        step: 'complete'
      });
    },
    error: function(response) {
      response['headers'] = headers;
      response['url'] = _this.endpoint + "requests";
      window.localStorage.setItem('response', JSON.stringify(response));

      const replacedParams = {
        question: undefined,
        step: 'error'
      }
      if(params.referredBy) {replacedParams.referrer = params.referredBy}
      replaceParamByName(replacedParams);
    }
  });
}

/**
 * Inject error message in the template
 */
Questionnaire.prototype.throwError = function() {
  const response = JSON.parse(window.localStorage.getItem('response'));
  const error = response.responseJSON && response.responseJSON.error;
  const errors = response.responseJSON && response.responseJSON.errors;

  if (error) {
    $('p.large').html(error);
  } else if (errors) {
    if (errors.code) {
      $('p.large').html(errors.code);
    } else if (errors.email) {
      $('p.large').html(errors.email);
    } else if (errors.phone) {
      $('p.large').html(errors.phone);
    } else if (errors.name) {
      $('p.large').html(errors.name);
    } else if (errors.amount) {
      $('p.large').html(errors.amount[0]);
    } else if (errors.user) {
      $('p.large').html(errors.user[0]);
    } else if (errors.collaborators) {
      $('p.large').html(errors.collaborators[0]);
    } else if (errors.referredBy) {
      $('p.large').html(errors.referredBy[0]);
    }
  }
};

Questionnaire.prototype.reload = function(event) {
  const response = JSON.parse(window.localStorage.getItem('response'));
  const error = response.responseJSON.error;
  const errors = response.responseJSON.errors;
  let question = '';

  if (error) {
    if (response.status === 409) { // 409 => conflict in email use so redirection to email input
      question = 'finalize-application';
    } else {
      question = 'company';
    }
  } else if (errors) {
    if (errors.code) {
      question = 'company';
    } else if (errors.email || errors.referredBy) {
      question = 'finalize-application';
    } else if (errors.amount) {
      question = 'amount';
    } else if (errors.name || errors.user || errors.phone || errors.collaborators) {
      question = 'personal-info';
    }
  }

  replaceParamByName({ question, step: undefined });

  event.preventDefault();
}


/**
 * is current country has leases offer
 * @returns BOOL
 */
Questionnaire.prototype.isLeaseAvailable = function() {
  // const hasLease = this.locale === 'ES' || this.locale === 'FR';
  return true;
}

/**
 * GTM datalayer tracking
 * @param {*} event
 * @param {*} params
 */
Questionnaire.prototype.track = function(event, params) {
  if (!!window.dataLayer) {
    params = params || {};

    params.event = event;
    params.country = this.locale;

    window.dataLayer.push(params);
  }
}
